import { type UseQueryResult, useQuery } from 'react-query';
import { PerformanceRuleApprovalService } from '../../services/wealthlane-award-services';

const useGetPerformanceRuleApprovalType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const PerformanceRuleApprovalType = useQuery(
    ['getPerformanceRuleApprovalType'],
    async () => {
      return await handleRequest(
        PerformanceRuleApprovalService.getApiAwardApiAppPerformanceRuleApprovalPerformanceRuleTypes()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return PerformanceRuleApprovalType;
};

export default useGetPerformanceRuleApprovalType;
